import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import animations from 'src/styles/animations';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), animations.spin), {}, {
  textContent: {
    '& p': {
      margin: '0'
    }
  },
  rulesContainer: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '99',
    padding: '36px',
    position: 'absolute',
    overflow: 'hidden auto',
    backgroundColor: palette.shades[200]
  },
  link: {
    color: palette.primary.dark
  },
  modalContent: {
    padding: '24px 40px',
    position: 'relative'
  },
  modalContentExpanded: {
    minHeight: '400px'
  },
  modalFooter: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[300])
  }
}));
export default useStyles;